import { Redirect } from 'expo-router'

export default function LegacyTabsNotifications() {
  return <Redirect href="/notifications" />
}
